var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEncuesta({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.66602V5.99935H6V4.66602H10Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11268 3.33268C6.03935 3.12268 5.99935 2.89935 5.99935 2.66602C5.99935 1.56268 6.89602 0.666016 7.99935 0.666016C9.10268 0.666016 9.99935 1.56268 9.99935 2.66602C9.99935 2.89935 9.95935 3.12268 9.88602 3.33268H13.3327V15.3327H2.66602V3.33268H6.11268ZM3.99935 4.66602V13.9993H11.9993V4.66602H3.99935ZM7.99935 3.33268C8.36602 3.33268 8.66602 3.03268 8.66602 2.66602C8.66602 2.29935 8.36602 1.99935 7.99935 1.99935C7.63268 1.99935 7.33268 2.29935 7.33268 2.66602C7.33268 3.03268 7.63268 3.33268 7.99935 3.33268Z",
    fill: "#7B7B7B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEncuesta);
export default __webpack_public_path__ + "static/media/icon-encuesta.6832ceb8.svg";
export { ForwardRef as ReactComponent };